<form [formGroup]="storeTeamForm">
  <div class="row d-flex justify-content-between">
    <div class="col-lg-6 col-12 d-flex flex-column mb-2">
      <label for="" class="label-sty">Email</label>
      <input [disabled]="isLoggedIn" matInput type="text" class="cutom-input-sty form-control" placeholder="Enter Email" formControlName="Email"
        (change)="onChangeEmail()">
      <mat-error class="mt-2"
        *ngIf="storeTeamForm.get('Email').errors?.required  && (storeTeamForm.get('Email').dirty || storeTeamForm.get('Email').touched)">
        Email Id is required
      </mat-error>
      <mat-error class="mt-2" *ngIf="storeTeamForm.get('Email').errors?.pattern">
        Please enter a valid email address
      </mat-error>
    </div>

    <div class="col-lg-6 col-12 d-flex flex-column mb-2">
      <label for="" class="label-sty">Organization. <span class="text-danger">*</span></label>
      
        <ng-select class="custom-dropdown" [items]="organizationArray" bindLabel="name" bindValue="id"
          formControlName="OrganizationId" placeholder="Search for schools, teams, associations & more…"
          name="OrganizationId" [(ngModel)]="selectedOrganization" [clearable]="true" [searchable]="true"
          (change)="onChangeOrganization()" [searchFn]="customSearch">
          <ng-template ng-option-tmp let-item="item">
            <div class="custom-option">
              <div *ngIf="item.id == 'Add'" style="color: rgb(147 137 137);">
                <strong>{{ item?.name }}</strong>
              </div>
              <ng-container *ngFor="let part of splitName(item?.name)">
                <span [ngClass]="{'highlight': part.toLowerCase() === searchText?.toLowerCase()}">{{ part
                  }}</span>
              </ng-container>
              <div *ngIf="item.id != 'Add'"><strong>{{ cleanMascoText(item) }}</strong></div>
            </div>
          </ng-template>
        </ng-select>
        <mat-error class="mt-2"
          *ngIf="storeTeamForm.get('OrganizationId').errors?.required  && (storeTeamForm.get('OrganizationId').dirty || storeTeamForm.get('OrganizationId').touched)">
          Organization is required
        </mat-error>
    </div>
    <div class="col-lg-6 col-12 d-flex flex-column mb-2">
      <label for="" class="label-sty">Market/Audience <span class="text-danger">*</span></label>
      <ng-select class="custom-dropdown" [items]="markets" bindLabel="name" bindValue="id"
        formControlName="DepartmentId" placeholder="Search Market/sport" name="DepartmentId"
        [(ngModel)]="selectedmarket" [clearable]="true" [searchable]="true" (change)="onChangeMarket()"
        [searchFn]="customSearchMark">
        <ng-template ng-option-tmp let-item="item">
          <div class="custom-option">
            <ng-container *ngFor="let part of splitNameMark(item?.name)">
              <span [ngClass]="{'highlight': part.toLowerCase() === searchTextMark?.toLowerCase()}">{{ part
                }}</span>
            </ng-container>
          </div>
        </ng-template>
      </ng-select>
      <mat-error class="mt-2"
        *ngIf="storeTeamForm.get('DepartmentId').errors?.required  && (storeTeamForm.get('DepartmentId').dirty || storeTeamForm.get('DepartmentId').touched)">
        Market/Audience is required
      </mat-error>
    </div>
  </div>

  <!-- Button moved outside the main row and centered -->
  <div class="row mt-3">
    <div class="col-12 text-center">
      <button class="btn btn-primary proceed-button" [disabled]="storeTeamForm.invalid" matStepperNext
        (click)="next('first')">Proceed To Store</button>
    </div>
  </div>
</form>